export const data =
  // 20220603111329
  // https://fakestoreapi.com/products

  [
    {
      id: 1,
      title: "Peace lily",
      price: 109.95,
      description:
        "Your perfect pack for everyday use and walks in the forest. Stash your laptop (up to 15 inches) in the padded sleeve, your everyday",
      category: "indoor",
      image:
        "https://hips.hearstapps.com/hmg-prod.s3.amazonaws.com/images/indoor-plants-1582229387.jpg",
      rating: { rate: 3.9, count: 120 },
    },
    {
      id: 2,
      title: "Parlour Palm ",
      price: 22.3,
      description:
        "Slim-fitting style, contrast raglan long sleeve, three-button henley placket, light weight & soft fabric for breathable and comfortable wearing. And Solid stitched shirts with round neck made for durability and a great fit for casual fashion wear and diehard baseball fans. The Henley style round neckline includes a three-button placket.",
      category: "indoor",
      image: "https://m.media-amazon.com/images/I/61ygmGPJiAL._SL1500_.jpg",
      rating: { rate: 4.1, count: 259 },
    },
    {
      id: 3,
      title: "Flamingo Lily ",
      price: 55.99,
      description:
        "great outerwear jackets for Spring/Autumn/Winter, suitable for many occasions, such as working, hiking, camping, mountain/rock climbing, cycling, traveling or other outdoors. Good gift choice for you or your family member. A warm hearted love to Father, husband or son in this thanksgiving or Christmas Day.",
      category: "indoor",
      image:
        "https://hips.hearstapps.com/hmg-prod.s3.amazonaws.com/images/wh-index-2000x1000-indoorplants-1623171089.jpg",
      rating: { rate: 4.7, count: 500 },
    },
    {
      id: 4,
      title: "English Ivy",
      price: 15.99,
      description:
        "The color could be slightly different between on the screen and in practice. / Please note that body builds vary by person, therefore, detailed size information should be reviewed below on the product description.",
      category: "indoor",
      image:
        "https://hips.hearstapps.com/vader-prod.s3.amazonaws.com/1623958717-the-sill_anthurium-pink_variant_small_bryant_blush_1440x.jpg?crop=1xw:1xh;center,top",
      rating: { rate: 2.1, count: 430 },
    },
    {
      id: 5,
      title: "Boston Fern",
      price: 695,
      description:
        "From our Legends Collection, the Naga was inspired by the mythical water dragon that protects the ocean's pearl. Wear facing inward to be bestowed with love and abundance, or outward for protection.",
      category: "indoor",
      image:
        "https://hips.hearstapps.com/hmg-prod.s3.amazonaws.com/images/indoor-plants-jade-1646165642.jpeg?crop=0.718xw:0.600xh;0,0.400xh&resize=480:*",
      rating: { rate: 4.6, count: 400 },
    },
    {
      id: 6,
      title: "Variegated snake plant  ",
      price: 168,
      description:
        "Satisfaction Guaranteed. Return or exchange any order within 30 days.Designed and sold by Hafeez Center in the United States. Satisfaction Guaranteed. Return or exchange any order within 30 days.",
      category: "indoor",
      image:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS1CLJl4wy8oWY53tCUewRSQyC_ZYgH1sHigA&usqp=CAU",
      rating: { rate: 3.9, count: 70 },
    },
    {
      id: 7,
      title: "White Gold Plated Princess",
      price: 9.99,
      description:
        "Classic Created Wedding Engagement Solitaire Diamond Promise Ring for Her. Gifts to spoil your love more for Engagement, Wedding, Anniversary, Valentine's Day...",
      category: "indoor",
      image:
        "https://www.gardeningknowhow.com/wp-content/uploads/2021/07/houseplants-for-interior.jpg",
      rating: { rate: 3, count: 400 },
    },
    {
      id: 8,
      title: "Pierced Owl Rose",
      price: 10.99,
      description:
        "Rose Gold Plated Double Flared Tunnel Plug Earrings. Made of 316L Stainless Steel",
      category: "indoor",
      image:
        "https://i1.fnp.com/images/pr/l/v20211029182934/bamboo-syngonium-jade-money-plant-set_1.jpg",
      rating: { rate: 1.9, count: 100 },
    },
    {
      id: 9,
      title: "Spider Plant",
      price: 64,
      description:
        "USB 3.0 and USB 2.0 Compatibility Fast data transfers Improve PC Performance High Capacity; Compatibility Formatted NTFS for Windows 10, Windows 8.1, Windows 7; Reformatting may be required for other operating systems; Compatibility may vary depending on user’s hardware configuration and operating system",
      category: "indoor",
      image:
        "https://hips.hearstapps.com/vader-prod.s3.amazonaws.com/1557256241-pot-plant-close-up-elevated-view-high-res-stock-photography-829464-001-1557256205.jpg",
      rating: { rate: 3.3, count: 203 },
    },
    {
      id: 10,
      title: "Corn plant ",
      price: 109,
      description:
        "Easy upgrade for faster boot up, shutdown, application load and response (As compared to 5400 RPM SATA 2.5” hard drive; Based on published specifications and internal benchmarking tests using PCMark vantage scores) Boosts burst write performance, making it ideal for typical PC workloads The perfect balance of performance and reliability Read/write speeds of up to 535MB/s/450MB/s (Based on internal testing; Performance may vary depending upon drive capacity, host device, OS and application.)",
      category: "indoor",
      image:
        "https://cdn.cdnparenting.com/articles/2019/01/12114103/519235318-H.jpg",
      rating: { rate: 2.9, count: 470 },
    },
    {
      id: 11,
      title: "Lavender",
      price: 109,
      description:
        "3D NAND flash are applied to deliver high transfer speeds Remarkable transfer speeds that enable faster bootup and improved overall system performance. The advanced SLC Cache Technology allows performance boost and longer lifespan 7mm slim design suitable for Ultrabooks and Ultra-slim notebooks. Supports TRIM command, Garbage Collection technology, RAID, and ECC (Error Checking & Correction) to provide the optimized performance and enhanced reliability.",
      category: "outdoor",
      image:
        "https://plantingman.com/wp-content/uploads/2019/05/Scarlet-sage-Flowering-plant.jpg",
      rating: { rate: 4.8, count: 319 },
    },
    {
      id: 12,
      title: "Canna Lily",
      price: 114,
      description:
        "Expand your PS4 gaming experience, Play anywhere Fast and easy, setup Sleek design with high capacity, 3-year manufacturer's limited warranty",
      category: "outdoor",
      image:
        "http://cdn.shopify.com/s/files/1/0047/9730/0847/products/nurserylive-combo-packs-plants-evergreen-plants-for-terrace-garden-16968851325068.jpg?v=1634219247",
      rating: {
        rate: 4.8,
        count: 400,
      },
    },
    {
      id: 13,
      title: "Strawberry",
      price: 599,
      description:
        "21. 5 inches Full HD (1920 x 1080) widescreen IPS display And Radeon free Sync technology. No compatibility for VESA Mount Refresh Rate: 75Hz - Using HDMI port Zero-frame design | ultra-thin | 4ms response time | IPS panel Aspect ratio - 16: 9. Color Supported - 16. 7 million colors. Brightness - 250 nit Tilt angle -5 degree to 15 degree. Horizontal viewing angle-178 degree. Vertical viewing angle-178 degree 75 hertz",
      category: "outdoor",
      image:
        "https://www.gardendesign.com/pictures/images/675x529Max/site_3/colorful-foliage-plants-proven-winners_16616.jpg",
      rating: {
        rate: 2.9,
        count: 250,
      },
    },
    {
      id: 14,
      title: "Begonia",
      price: 999.99,
      description:
        "49 INCH SUPER ULTRAWIDE 32:9 CURVED GAMING MONITOR with dual 27 inch screen side by side QUANTUM DOT (QLED) TECHNOLOGY, HDR support and factory calibration provides stunningly realistic and accurate color and contrast 144HZ HIGH REFRESH RATE and 1ms ultra fast response time work to eliminate motion blur, ghosting, and reduce input lag",
      category: "outdoor",
      image:
        "https://irishtatler.com/uploads/assets/2020/6/sweetpotatoevine_on_unsplash.jpg",
      rating: {
        rate: 2.2,
        count: 140,
      },
    },
    {
      id: 15,
      title: "Herbs",
      price: 56.99,
      description:
        "Note:The Jackets is US standard size, Please choose size as your usual wear Material: 100% Polyester; Detachable Liner Fabric: Warm Fleece. Detachable Functional Liner: Skin Friendly, Lightweigt and Warm.Stand Collar Liner jacket, keep you warm in cold weather. Zippered Pockets: 2 Zippered Hand Pockets, 2 Zippered Pockets on Chest (enough to keep cards or keys)and 1 Hidden Pocket Inside.Zippered Hand Pockets and Hidden Pocket keep your things secure. Humanized Design: Adjustable and Detachable Hood and Adjustable cuff to prevent the wind and water,for a comfortable fit. 3 in 1 Detachable Design provide more convenience, you can separate the coat and inner as needed, or wear it together. It is suitable for different season and help you adapt to different climates",
      category: "outdoor",
      image:
        "https://indiagardening.com/wp-content/uploads/2020/11/Bougainvillea.jpg",
      rating: {
        rate: 2.6,
        count: 235,
      },
    },
    {
      id: 16,
      title: "Rose",
      price: 29.95,
      description:
        "100% POLYURETHANE(shell) 100% POLYESTER(lining) 75% POLYESTER 25% COTTON (SWEATER), Faux leather material for style and comfort / 2 pockets of front, 2-For-One Hooded denim style faux leather jacket, Button detail on waist / Detail stitching at sides, HAND WASH ONLY / DO NOT BLEACH / LINE DRY / DO NOT IRON",
      category: "outdoor",
      image:
        "https://www.thespruce.com/thmb/GknKO-Ur-JNP8WRIrbu2aCEG4Q4=/1772x1329/smart/filters:no_upscale()/-easy-to-grow-outdoor-plants-2132285-2-4ff12990aded4020832c8d39fe8074a3.jpg",
      rating: {
        rate: 2.9,
        count: 340,
      },
    },
    {
      id: 17,
      title: "Chrysanthemum",
      price: 39.99,
      description:
        "Lightweight perfet for trip or casual wear---Long sleeve with hooded, adjustable drawstring waist design. Button and zipper front closure raincoat, fully stripes Lined and The Raincoat has 2 side pockets are a good size to hold all kinds of things, it covers the hips, and the hood is generous but doesn't overdo it.Attached Cotton Lined Hood with Adjustable Drawstrings give it a real styled look.",
      category: "outdoor",
      image:
        "https://hips.hearstapps.com/hmg-prod.s3.amazonaws.com/images/dyffryn-fernant-gardens-dinas-pembrokeshire-wales-royalty-free-image-1644437953.jpg",
      rating: {
        rate: 3.8,
        count: 679,
      },
    },
    {
      id: 18,
      title: "Hydrangea",
      price: 9.85,
      description:
        "95% RAYON 5% SPANDEX, Made in USA or Imported, Do Not Bleach, Lightweight fabric with great stretch for comfort, Ribbed on sleeves and neckline / Double stitching on bottom hem",
      category: "outdoor",
      image:
        "https://wl-brightside.cf.tsp.li/resize/728x/jpg/227/636/cc241a53558ea8116485f968ad.jpg",
      rating: {
        rate: 4.7,
        count: 130,
      },
    },
    {
      id: 19,
      title: "Succulents",
      price: 7.95,
      description:
        "100% Polyester, Machine wash, 100% cationic polyester interlock, Machine Wash & Pre Shrunk for a Great Fit, Lightweight, roomy and highly breathable with moisture wicking fabric which helps to keep moisture away, Soft Lightweight Fabric with comfortable V-neck collar and a slimmer fit, delivers a sleek, more feminine silhouette and Added Comfort",
      category: "outdoor",
      image:
        "https://i.pinimg.com/564x/29/b0/c4/29b0c4ed13a0fac53cdaec7bc4c3294f--potted-flowers-potted-plants.jpg",
      rating: {
        rate: 4.5,
        count: 146,
      },
    },
    {
      id: 20,
      title: "Palms",
      price: 12.99,
      description:
        "95%Cotton,5%Spandex, Features: Casual, Short Sleeve, Letter Print,V-Neck,Fashion Tees, The fabric is soft and has some stretch., Occasion: Casual/Office/Beach/School/Home/Street. Season: Spring,Summer,Autumn,Winter.",
      category: "outdoor",
      image:
        "http://cdn.shopify.com/s/files/1/0047/9730/0847/products/nurserylive-rudraksha-tree-plant.jpg?v=1634227766",
      rating: {
        rate: 3.6,
        count: 145,
      },
    },
  ];
